import { CSSObject } from '@mui/material';

import { transparentize } from 'color2k';

// import { lighten } from 'color2k';

import { grey, primary, red } from '../options/palette';
import transitions from '../options/transitions';

const inputBase: CSSObject = {
  styleOverrides: {
    root: {
      'position': 'relative',

      'background': grey[50],
      'backgroundColor': grey[50],
      'borderWidth': '2px',
      'borderStyle': 'solid',
      'borderColor': grey[200],
      'borderRadius': '10px',

      'flex': 1,

      'opacity': 1,

      'padding': '28px 16px 8px 16px',
      'marginTop': '0px !important',

      'transition': `${transitions.duration?.short}ms ${transitions.easing?.easeOut}`,

      '&:before': {
        display: 'none'
      },

      '&:after': {
        display: 'none'
      },

      '&.Mui-focused': {
        'background': transparentize(primary, 0.9),
        'backgroundColor': transparentize(primary, 0.9),
        'borderColor': primary,

        '& .MuiInputAdornment-positionEnd': {
          color: grey[900]
        }
      },

      '&.Mui-disabled': {
        opacity: 0.5,

        pointerEvents: 'none'
      },

      '&.Mui-error': {
        'background': red[50],
        'backgroundColor': red[50],
        'borderColor': red[500],

        '& .MuiInputAdornment-positionEnd': {
          color: red[500]
        },

        '&:hover': {
          background: red[50],
          backgroundColor: red[50],
          borderColor: red[500]
        }
      },

      '& .MuiInputAdornment-positionEnd': {
        position: 'absolute',
        top: '50%',
        right: '16px',
        transform: 'translateY(-50%) !important',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        background: 'transparent',
        backgroundColor: 'transparent'
      },

      '*, *::before, &::after': {
        transition: `${transitions.duration?.short}ms ${transitions.easing?.easeOut}`
      }
    },
    // inputAdornedStart: {
    //   //     position: absolute;
    //   // top: 50%;
    //   // left: 50%;
    //   // transform: translate(-50%, -50%)

    //   'background': 'transparent',
    //   'backgroundColor': 'transparent',

    //   '&.Mui-focused': {
    //     color: grey[900],
    //     // padding: theme.spacing(2.5, 0, 1, 1),
    //     paddingRight: '0 !important'
    //   },

    //   '&.Mui-error': {
    //     color: red[500]
    //     // padding: theme.spacing(2.5, 0, 1, 1)
    //   }
    // },

    // sizeSmall: {},
    // multiline: {},
    input: {
      color: grey[900],
      borderRadius: 0,

      padding: 0
    }

    // "& input[type='number']": {
    //   '-moz-appearance': 'textfield'
    // },

    // '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
    //   '-webkit-appearance': 'none'
    // }
    // }
  }
};

export default inputBase;
